// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SupportAlert } from '@/components/support-alert';
import { Snackbar } from '@mui/material';

interface Props {
  /**
   * If true, the alert will be displayed.
   */
  isOpen: boolean;

  /**
   * A message to display in the alert.
   */
  message: string;

  /**
   * A callback fired when the alert requests to be closed.
   */
  onClose: () => void;
}

/**
 * A dismissable alert that renders a message along with a standard Hardfin
 * support message.
 */
export function SupportSnackbar(props: Props) {
  return (
    <Snackbar
      open={props.isOpen}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <SupportAlert message={props.message} onClose={props.onClose} />
    </Snackbar>
  );
}
